module.exports = __webpack_public_path__ + "static/media/nicolas.a906efcc.jpg";